import { render, staticRenderFns } from "./OAppContent.vue?vue&type=template&id=6d73f977&"
import script from "./OAppContent.vue?vue&type=script&lang=js&"
export * from "./OAppContent.vue?vue&type=script&lang=js&"
import style0 from "./OAppContent.vue?vue&type=style&index=0&id=6d73f977&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports